/*
 * @Description:
 * @Author: wan.bruce
 * @Date: 2018/9/14
 * @Last Modified by: tao.zhu
 * @Last Modified time: 2018-09-25 13:25:54
 */

import * as auth from './auth';

export default auth;

